import { axios } from '@/utils/request'

const api = {
    CustomerList:'/624e9e19a8f6d',
    add: '/624e9938be956',
    bind: '/624e9c07929be',
    delete: '/624eab2e0a3a9',
    cancelBind: '/624e9c07929be'
}

export default {
    // 获取列表
    getCustomerList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.CustomerList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    }, 
    // 新增
    add: (parameter) => {
        return axios({
            url: api.add,
            method: 'post',
            data: parameter
        })
    },
    // 关联机器人
    bind: (parameter) => {
        return axios({
            url: api.bind,
            method: 'post',
            data: parameter
        })
    },
    // 删除API密钥
    delete: (parameter) => {
        return axios({
            url: api.delete,
            method: 'post',
            data: parameter
        })
    },
    // 取消关联机器人
    cancelBind: (parameter) => {
        return axios({
            url: api.cancelBind,
            method: 'post',
            data: parameter
        })
    }
}
